import { jsx as T } from "react/jsx-runtime";
import { useToast as h } from "@chakra-ui/react";
import { Alert as w } from "../Alert/Alert.mjs";
const x = () => {
  const r = h(), o = ({
    description: s,
    duration: a = 5e3,
    position: n = "top-right",
    showCloseButton: e = !0,
    status: c = "info",
    ...i
  }) => {
    r({
      duration: a,
      position: n,
      render: ({ id: t, onClose: u }) => /* @__PURE__ */ T(
        w,
        {
          status: c,
          id: t ? `toast-${t}` : void 0,
          onClose: u,
          showCloseButton: e,
          variant: "toast",
          ...i,
          children: s
        }
      )
    });
  };
  return { showToast: o, showInfoToast: (s) => {
    o({ status: "info", ...s });
  }, showWarningToast: (s) => {
    o({ status: "warning", ...s });
  }, showSuccessToast: (s) => {
    o({ status: "success", ...s });
  }, showErrorToast: (s) => {
    o({ status: "error", ...s });
  } };
};
export {
  x as useToast
};
